// eslint-disable-next-line import/no-unresolved
import * as React from 'react';
import { ReadOnlyThemeContext, ThemeContext } from './context';
import { getTheme } from './utils';

/**
 * A hook to use the closest theme context.
 *
 * @param props - Current component props
 * @param styles - The css modules styles for the component
 *
 * @example
 * const { themeClass } = useTheme({ colorScheme, theme }, styles);
 */
export var useTheme = function useTheme(props) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return getTheme(props, React.useContext(ThemeContext), React.useContext(ReadOnlyThemeContext), styles);
};
//# sourceMappingURL=useTheme.js.map